import { getCountry } from "@/apis/addressApi";
import {
  getCostCenter,
  getGLAccountList,
  getMaterialGroupList,
} from "@/apis/sap.api";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

/**
 * 获取成本中心 options
 * @param fdFactory
 * @returns
 */
export const useCostCenterOptions = (fdFactory: string) => {
  const result = useQuery({
    queryKey: ["CostCenterOptions", fdFactory],
    queryFn: () => getCostCenter(fdFactory),
    enabled: !!fdFactory,
  });

  const options =
    result.data?.data.data.map((item) => {
      return {
        label: item.f102,
        value: item.f101,
      };
    }) || [];

  return options;
};

/** 获取物料组 options */
export const useMaterialGroupOptions = () => {
  const result = useQuery({
    queryKey: ["MaterialGroupOptions"],
    queryFn: () => getMaterialGroupList({}),
  });

  const options =
    result.data?.data.data.map((item) => {
      return {
        label: item.f102 || item.f104 || item.f103,
        value: item.f101,
      };
    }) || [];

  return options;
};

/** 获取会计科目 options */
export const useGLAccountOptions = (fdFactory: string) => {
  const result = useQuery({
    queryKey: ["GLAccountOptions"],
    queryFn: () =>
      getGLAccountList({
        p02: fdFactory,
      }),
    enabled: !!fdFactory,
  });

  const options =
    result.data?.data.data.map((item) => {
      return {
        label: item.f102 || item.f104 || item.f103,
        value: item.f101,
      };
    }) || [];

  return options;
};

/** 获取国家 options */
export const useCountryOptions = () => {
  const result = useQuery({
    queryKey: ["CountryOptions"],
    queryFn: () => getCountry(),
  });

  const options =
    result.data?.data.data.map((item) => {
      return {
        label: item.name,
        value: item.name,
      };
    }) || [];

  return options;
};

/** 物料类型 */
export const useMaterialTypeOptions = () => {
  const { t } = useTranslation("option");

  const options = [
    {
      label: t("生产物料"),
      value: "生产物料",
    },
    {
      label: t("非生产物料"),
      value: "非生产物料",
    },
  ];

  return options;
};
